import { createContext, useContext, useState, type ReactNode } from 'react';

interface UpgradePlanContextValue {
  capacidadActiva: string | null;
  abrirModalUpgrade: (codigo: string) => void;
  cerrarModalUpgrade: () => void;
}

const UpgradePlanContext = createContext<UpgradePlanContextValue | undefined>(undefined);

export function UpgradePlanProvider({ children }: { children: ReactNode }) {
  const [capacidadActiva, setCapacidadActiva] = useState<string | null>(null);

  return (
    <UpgradePlanContext.Provider
      value={{
        capacidadActiva,
        abrirModalUpgrade: setCapacidadActiva,
        cerrarModalUpgrade: () => setCapacidadActiva(null),
      }}
    >
      {children}
    </UpgradePlanContext.Provider>
  );
}

export function useUpgradePlan(): UpgradePlanContextValue {
  const context = useContext(UpgradePlanContext);
  if (!context) throw new Error('useUpgradePlan debe usarse dentro de UpgradePlanProvider');
  return context;
}
